import { render, staticRenderFns } from "./eg-colored-dot-box.vue?vue&type=template&id=3d7f4865&scoped=true&"
import script from "./eg-colored-dot-box.vue?vue&type=script&lang=js&"
export * from "./eg-colored-dot-box.vue?vue&type=script&lang=js&"
import style0 from "./eg-colored-dot-box.vue?vue&type=style&index=0&id=3d7f4865&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7f4865",
  null
  
)

export default component.exports